import React from 'react';

const AppContext = React.createContext({
  formState: {},
  // tslint:disable-next-line: no-empty
  setFormState: (state) => { },
  forceRender: false,
  // tslint:disable-next-line: no-empty
  setForceRender: (state) => { },
  // do nothing
  changeIsPublish: (value) => { },
  isOABFormPublished: false
});
const { Provider, Consumer } = AppContext;

const AppContextProvider = (props) => {
  const [formState, setFormStateFn] = React.useState({});
  const [forceRender, setForceRender] = React.useState(false);
  const [isOABFormPublished, setOABFormIsPublished] = React.useState<boolean>(false)

  const setFormState = (newFormState) => {
    setFormStateFn({
      ...formState,
      ...newFormState,
    })
  }

  const changeIsPublish = (value) => {
    setOABFormIsPublished(value);
  }

  return (
    <Provider
      value={{ formState, setFormState, forceRender, isOABFormPublished, changeIsPublish, setForceRender } as any}
    >
      {props.children}
    </Provider>
  );
};

export { AppContext, AppContextProvider, Consumer as AppContextConsumer };
